import AddCircleIcon from "@mui/icons-material/AddCircle";
import Image from "next/image";
import { Container } from "@mui/system";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { compressImage, uploadToFbStorage } from "src/lib/global";
import { db } from "api_config/firebase-configuration";
import { useContext } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useRouter } from "next/router";
import { LocalizationContext } from "../../lib/context";

const ProfileCoverImage = ({
  username,
  coverImage,
  canEdit,
  user,
}: {
  username: string;
  coverImage: string;
  canEdit: boolean;
  user: any;
}) => {
  const router = useRouter();
  const { profilePage } = useContext(LocalizationContext).localeStrings;

  async function addBannerImage(file: any) {
    // UPDATING COVER IMAGE
    try {
      const url = await uploadToFbStorage(file, `coverImages/${user.uid}`);
      await updateDoc(doc(db, "users", user.uid), {
        coverImage: file ? url : null,
      });
      await setDoc(
        doc(db, "usersPublic", user.uid),
        {
          coverImage: file ? url : null,
        },
        { merge: true }
      );
      router.reload();
    } catch (e) {
      // console.log("fb error7: ", e);
    }
  }

  return (
    <div className="profile__coverImage">
      {canEdit && (
        <div className="profile__add-banner flex pointer">
          <FileUploader
            name="profImage"
            types={["jpeg", "png", "jpg", "GIF"]}
            maxSize={100}
            handleChange={(file: any) => {
              compressImage(file).then((r) => {
                addBannerImage(file);
              });
            }}
            children={
              <>
                <AddCircleIcon sx={{ color: "#ffffff" }} fontSize="small" />
                <p className="body-1 fw-600 white">
                  {profilePage.addBannerButton}
                </p>
              </>
            }
          />
        </div>
      )}

      <Container className="profile__coverImage--text">
        <h1 className="primary-lighten-2">{profilePage.dronePilot}</h1>
      </Container>
      <Image
        priority={true}
        alt={username + " cover image"}
        src={coverImage ?? "/assets/coverImagePlaceholder.svg"}
        layout="fill"
        sizes="(min-width: 100vw) 100vw,
          (min-width: 100vw) 100vw,
         100vw"
        objectFit="cover"
        quality={50}
      />
    </div>
  );
};

export default ProfileCoverImage;
